import { useState, useEffect, useRef, useCallback } from "react";
import CommentCard from "./CommentCard";
import MediaComponent from "../MediaComponent";
import SubmissionData from "./SubmissionData";
import ScrollContainer from "react-indiana-drag-scroll";
import { motion, AnimatePresence } from "framer-motion";

function RelatedPostsSlider({ data }) {
  const [dataArr, setDataArr] = useState(data);
  const [idToData, setIdToData] = useState(null);
  const [globalSoundEnabled, setGlobalSoundEnabled] = useState(false);
  const videoRefs = useRef({});

  const scrollRef = useRef(null);

  console.log("the related posts data being pushed: ", data);

  // State to track the dragging behavior
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  // Memoize event handlers for performance
  const handleMouseDown = useCallback((e) => {
    if (!scrollRef.current) return;
    setIsDragging(true);
    // Get the initial vertical position of the mouse and the initial scroll position
    setStartY(e.pageY - scrollRef.current.offsetTop);
    setScrollTop(scrollRef.current.scrollTop);
  }, []);

  const handleMouseLeaveOrUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  const handleMouseMove = useCallback(
    (e) => {
      if (!isDragging || !scrollRef.current) return;
      e.preventDefault(); // Prevent default browser behavior (like text selection)
      const y = e.pageY - scrollRef.current.offsetTop;
      const walk = y - startY; // Calculate how far the mouse has moved vertically
      scrollRef.current.scrollTop = scrollTop - walk; // Update the scroll position
    },
    [isDragging, startY, scrollTop],
  );

  console.log("Data in post slider: ", data);

  useEffect(() => {
    const fetchVideoPaths = async (queryString) => {
      try {
        const res = await fetch(
          `https://genz-staging.feeltiptop.com/api/social_glass/getPostsDataArr?${queryString}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const { data: json_data } = await res.json();
        const temp = {};
        json_data.forEach((element) => {
          temp[element.post_id] = element;
        });
        setIdToData(temp);
      } catch (error) {
        console.error("Failed to fetch video paths:", error);
      }
    };

    if (dataArr?.length) {
      const queryString = dataArr
        .map((curr) => `postIDs=${curr.postId}`)
        .join("&");
      fetchVideoPaths(queryString);
    }
  }, [dataArr]);

  const formatCount = (num) => {
    const digitLength = Math.floor(Math.log10(num)) + 1;

    if (digitLength <= 4) {
      return `~${num.toLocaleString()}`;
    } else if (num < 1000000) {
      return `~${(num / 1000).toFixed(1).replace(/\.0$/, "")}k`;
    } else {
      return `~${(num / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
    }
  };

  const handleManualMute = () => {
    setGlobalSoundEnabled(false);
    Object.values(videoRefs.current).forEach((v) => {
      if (v) v.muted = true;
    });
  };

  const handleManualUnmute = () => {
    setGlobalSoundEnabled(true);
    Object.values(videoRefs.current).forEach((v) => {
      if (v) v.muted = false;
    });
  };

  const renderMedia = (postId, username, index) => {
    if (!idToData || !idToData[postId]) return null;
    const mediaInfo = idToData[postId];
    const platform = mediaInfo.platform?.toLowerCase();

    if (!["tiktok", "instagram", "youtube", "twitter"].includes(platform)) {
      return <p>Platform not supported</p>;
    }

    return (
      <MediaComponent
        postId={postId}
        username={username}
        index={index}
        idToData={idToData}
        videoRefs={videoRefs}
        handleManualMute={handleManualMute}
        handleManualUnmute={handleManualUnmute}
        muted={true}
        caption=""
        showIcon={true}
        isAutoPlay={false}
      />
    );
  };

  return (
    <div
      id="video-and-comments-container"
      className="mt-8 w-full justify-between space-x-4"
    >
      <ScrollContainer
        id="video-and-comments"
        className="flex h-auto max-h-[500px] min-w-[300px] flex-shrink-0 cursor-grab gap-x-8 space-x-2 rounded-lg active:cursor-grabbing"
      >
        <AnimatePresence initial={false} mode="wait">
          {dataArr?.map((data, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -40 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="flex h-[300px] w-auto flex-none overflow-hidden rounded-xl bg-white shadow-socialglass"
            >
              {/* Video container */}
              {idToData && (
                <div className="flex h-full w-[180px] flex-col items-center justify-center">
                  <div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-xl bg-black shadow-socialglass">
                    {idToData[data.postId]?.downloaded_path ? (
                      <>
                        <MediaComponent
                          postId={data.postId}
                          username={data.postUsername}
                          index={index}
                          idToData={idToData}
                          videoRefs={videoRefs}
                          handleManualMute={handleManualMute}
                          handleManualUnmute={handleManualUnmute}
                          muted={true}
                          caption=""
                          showIcon={true}
                          isAutoPlay={false}
                        />
                        <div className="absolute bottom-5 right-2 flex flex-col items-end gap-2">
                          <div className="flex flex-col items-center">
                            <img
                              src="/Group.svg"
                              alt="likes icon"
                              className="h-6 w-6 cursor-pointer opacity-80 hover:opacity-100"
                            />
                            <span className="text-xs text-white">
                              {formatCount(data.postLikes) ?? 0}
                            </span>
                          </div>
                          <div className="flex flex-col items-center">
                            <img
                              src="/Group (1).svg"
                              alt="comments icon"
                              className="h-6 w-6 cursor-pointer opacity-80 hover:opacity-100"
                            />
                            <span className="text-xs text-white">
                              {formatCount(data.commentsCount) ?? 0}
                            </span>
                          </div>
                          <div className="flex flex-col items-center">
                            <img
                              src="/Group (2).svg"
                              alt="other icon"
                              className="h-6 w-6 cursor-pointer opacity-80 hover:opacity-100"
                            />
                            <span className="text-xs text-white">--</span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="bg-black-200 flex h-full w-full items-center justify-center text-lg font-semibold text-gray-400">
                        Video Not Found
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Post info and comments */}

              <div className="flex h-full w-[400px] flex-col p-2 text-left">
                <div className="flex items-center gap-2">
                  <span className="text-lg font-bold">
                    {data.postUsername || "Missing"}
                  </span>
                </div>
                <div className="mt-1 text-sm text-gray-800">
                  {data.postDesc}
                </div>
                <div className="my-2 border-t border-gray-200" />
                <div className="mb-1 text-sm font-bold">Top Comments</div>
                <ScrollContainer
                  vertical={true}
                  className="hide-scrollbar flex max-h-full flex-col gap-1 overflow-y-auto py-6 pr-1"
                >
                  {data.topComments?.map((comment, cidx) => (
                    <CommentCard
                      key={cidx}
                      comment={comment}
                      textSize={"12px"}
                    />
                  ))}
                </ScrollContainer>
              </div>

              {/* Summary and audio analysis */}
              <div className="flex h-full w-auto flex-col items-end justify-start">
                {/* <h4 className="whitespace-nowrap rounded-lg bg-[#FAD8DA] p-2 text-sm">
              {data.commentsCount} submissions
            </h4> */}
                <SubmissionData postId={data.postId} postUrl={data.postUrl} />
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </ScrollContainer>
    </div>
  );
}

export default RelatedPostsSlider;
